import ImportData from "./ImportData";
import Reports from "./Reports";
import NEList from "./NEList";
import MicrowaveList from "./MicrowaveList";
import Dashboard from "./Dashboard";
import HubReport from "./HubReport";
import HLD from "./HLDReport";

const Transmission = {
  ImportData,
  Reports,
  Dashboard,
  NEList,
  MicrowaveList,
  HubReport,
  HLD
};

export default Transmission;
